var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 7.25C5.79493 7.25 7.25 5.79493 7.25 4C7.25 2.20507 5.79493 0.75 4 0.75C2.20507 0.75 0.75 2.20507 0.75 4C0.75 5.79493 2.20507 7.25 4 7.25Z",
    fill: "#ECECEC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.a34e868eec8ba8c997992958d89f1188.svg";
export { ForwardRef as ReactComponent };